/**
 * Scroller of "Maak je look compleet" (PIG-320 M6): arrows over the row, shown only when there is more to scroll to.
 * The cards come from the server (Mix & match) and from assets/bbd-rebuy-cart-crosssells.js (Rebuy).
 */
class BbdCartLook extends HTMLElement {
  /** @type {MutationObserver | null} */
  #observer = null;

  /** @type {ResizeObserver | null} */
  #resizeObserver = null;

  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    // scroll does not bubble, listen in the capture phase
    this.addEventListener('scroll', this.#updateArrows, { capture: true, passive: true });

    // Cards come and go (Rebuy loads late, a cart refresh morphs the server markup back in)
    this.#observer = new MutationObserver(() => this.#updateArrows());
    this.#observer.observe(this, { childList: true, subtree: true });

    this.#resizeObserver = new ResizeObserver(() => this.#updateArrows());
    this.#resizeObserver.observe(this);

    this.#updateArrows();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('scroll', this.#updateArrows, { capture: true });
    this.#observer?.disconnect();
    this.#resizeObserver?.disconnect();
  }

  /**
   * @param {Event} event
   */
  #onClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const arrow = event.target.closest('[data-tiles-arrow]');
    if (!(arrow instanceof HTMLElement)) return;

    const row = this.querySelector('[data-tiles-row]');
    if (!(row instanceof HTMLElement)) return;

    const direction = arrow.dataset.tilesArrow === 'next' ? 1 : -1;
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    row.scrollBy({ left: direction * row.clientWidth * 0.8, behavior });
  };

  #updateArrows = () => {
    const row = this.querySelector('[data-tiles-row]');
    const previous = this.querySelector('[data-tiles-arrow="previous"]');
    const next = this.querySelector('[data-tiles-arrow="next"]');
    if (!(row instanceof HTMLElement) || !(previous instanceof HTMLElement) || !(next instanceof HTMLElement)) return;

    // Only write when it changed, the observer would otherwise retrigger itself
    const hidePrevious = row.scrollLeft <= 1;
    const hideNext = row.scrollLeft + row.clientWidth >= row.scrollWidth - 1;
    if (previous.hidden !== hidePrevious) previous.hidden = hidePrevious;
    if (next.hidden !== hideNext) next.hidden = hideNext;
  };
}

if (!customElements.get('bbd-cart-look')) {
  customElements.define('bbd-cart-look', BbdCartLook);
}
